// extracted by mini-css-extract-plugin
export default {"load":"Loader_load__7ERn4"};